import { useCookies } from 'react-cookie';
import { useEffectOnce } from 'react-use';
import { useSelector } from 'src/client/redux';
import { PARTNER_BANNER_COOKIE } from 'src/shared/constants/cookies';

export const usePartnerBannerCookieManager = () => {
  const { partnerBannersEnabled = [] } = useSelector((state) => state.app.config);
  const [cookies, setCookie] = useCookies([PARTNER_BANNER_COOKIE]);

  const currentVisibleBanner = cookies[PARTNER_BANNER_COOKIE];

  useEffectOnce(() => {
    if (partnerBannersEnabled.length === 0) {
      return;
    }

    // If there's a banner, increment the counter to show the next one. If not,
    // randomly select one from the enabled banners.
    const bannerToShow = currentVisibleBanner
      ? (currentVisibleBanner % partnerBannersEnabled.length) + 1
      : Math.floor(Math.random() * partnerBannersEnabled.length) + 1;

    setCookie(PARTNER_BANNER_COOKIE, bannerToShow, { path: '/' });
  });
};
